import React, { useEffect } from 'react';
import { useSelector } from "react-redux";
import {renderCSS, renderScript} from "../../../common/util"
const Rules = (props) => {
    const userView = useSelector(state => state.sessionContextOidc?.userView);
    const canManageRules = userView?.permissions?.can_manage_rules;

    useEffect(()=>{
        if (!canManageRules) return;

        let isActive = true;
        const mountRules = () => {
            if (isActive && typeof window.rules_view === 'function') {
                window.rules_view();
            }
        };

        if (document.querySelector('link[data-id="infinity-rule-engine.css"]') === null) {
            renderCSS("infinity-rule-engine");
        }

        const ruleScript = document.querySelector('script[data-id="infinity-rule-engine.js"]');
        if (ruleScript === null) {
            renderScript("infinity-rule-engine")
                .then(mountRules)
                .catch((error) => console.error("Unable to load rule engine bundle", error));
        } else if (typeof window.rules_view === 'function') {
            mountRules();
        } else {
            ruleScript.addEventListener('load', mountRules, { once: true });
        }

        return () => {
            isActive = false;
            if (ruleScript) {
                ruleScript.removeEventListener('load', mountRules);
            }
            if (typeof window.rules_unMount === 'function') {
                window.rules_unMount();
            }
        };
    }, [canManageRules])

    return (
        <div className="secondLayout">
            <div id={"infinity-rule-engine"}></div>
        </div>
    );
}

export default Rules;
